/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-10-25 11:40:03
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-12-05 16:17:55
 * @FilePath: \community-backende:\community-frontend\src\service\poc.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { get, post } from './http'

const base = '/operating-platform/campaign/frontend/poc'

const poc = {
  // 获取poc创意列表
  getPocProductList: () => {
    return get(`${base}/product/display`)
  },
  // 获取faq
  getFaq: () => {
    return get(`${base}/homepage/faq`)
  },
  // 获取首页作品回顾
  getHomeReview: () => {
    return get(`${base}/homepage/review`)
  },
  // 获取首页最佳创意
  getTopIdea: () => {
    return get(`${base}/homepage/topIdea`)
  },
  // 获取我的创意
  getMyIdeaList: () => {
    return get(`${base}/homepage/topIdea`)
  },
  // 支持创意
  supportIdea: (params) => {
    return post(`${base}/product/support`, params)
  },

  // 获取创意详情
  getPocDetail: (params) => {
    return get(`${base}/product/get`, params)
  },
  // 获取推荐的创意
  getRecommendPoc: (params) => {
    return get(`${base}/product/recommend`, params)
  },
  // 获取更新帖
  getPocUpdated: (params) => {
    return get(`${base}/product/updating`, params)
  },
  // 获取首页作品回顾
  getProductReview: (params) => {
    return get(`${base}/product/reviewing`, params)
  },
  // poc帖子列表
  getPocCircleList: (params) => {
    return get(`/circle/frontend/poc/thread/list`, params)
  },
  // 获取poc用户帖子列表
  getPocUserThreadList: (params) => {
    return get(`/user/frontend/poc/thread/page`, params)
  },
  // 获取poc用户帖子列表
  onNotify: (params) => {
    return post(`${base}/product/notify`, params)
  },
  // 获取公开招募横幅
  getRecruitBanner: () => {
    return get(`${base}/homepage/banner`)
  },
}
export default poc


